import {
  UPDATE_DPR_SKIP_STATE,
  RESET_DPR_SKIP_STATES,
  LOAD_DPR_SKIP_STATES_FOR_SECTION,
  UPDATE_DPR_SAVED_STATE
} from './types';

export const updateDprSkipState = (sowId, section, value) => ({
  type: UPDATE_DPR_SKIP_STATE,
  payload: {
    sowId,
    section,
    value: Boolean(value) // Store as boolean
  }
});

export const loadDprSkipStatesForSection = (sowId) => ({
  type: LOAD_DPR_SKIP_STATES_FOR_SECTION,
  payload: {
    sowId
  }
});

export const resetDprSkipStates = () => ({
  type: RESET_DPR_SKIP_STATES
});

export const updateDprSavedState = (sowId, section, value) => ({
  type: UPDATE_DPR_SAVED_STATE,
  payload: {
    sowId,
    section,
    value: Boolean(value)
  }
});

